import { render, staticRenderFns } from "./month-trade.vue?vue&type=template&id=638428c4&scoped=true&"
import script from "./month-trade.vue?vue&type=script&lang=js&"
export * from "./month-trade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638428c4",
  null
  
)

export default component.exports